'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$() {
  this.aTL = null;
  this.aTM = false;
  this.aTN = null;
  this.aTO = false;
}
export { $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ as $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ };
$p = $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$;
/** @constructor */
function $h_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$() {
}
export { $h_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ as $h_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ };
$h_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$.prototype = $p;
$p.aA = (function() {
  if ((!this.aTM)) {
    this.aTL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aTM = true;
  }
  return this.aTL;
});
$p.fI = (function() {
  if ((!this.aTO)) {
    this.aTN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeString__tapirCodec__Lsttp_tapir_Codec(this);
    this.aTO = true;
  }
  return this.aTN;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$, "app.data.document_templates$package$DocumentTemplateName$", ({
  GJ: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ as $d_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ };
var $n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$;
function $m_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$() {
  if ((!$n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$)) {
    $n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ = new $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$();
  }
  return $n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$;
}
export { $m_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ as $m_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$ };
//# sourceMappingURL=app.data.document_templates$package$-Document-Template-Name$.js.map
